module.exports = __webpack_public_path__ + "static/banner02-d54bfae0e7f5066690e31ed444f59142.png";